import { useState } from 'react';
import { useSearchParams, Link, useLocation, useNavigate } from 'react-router-dom';
import '../styles/AuthPage.css';

const AuthPage = () => {
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const mode = searchParams.get('mode');
  const location = useLocation();
  const navigate = useNavigate();
  const { returnTo, action, itemId } = location.state || {};

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Add authentication logic here
      await new Promise(resolve => setTimeout(resolve, 1000));
      // Handle success (redirect, etc.)
      handleLoginSuccess('fake-token'); // Replace with actual token
    } catch (error) {
      alert('Authentication failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleLoginSuccess = token => {
    localStorage.setItem('token', token);

    if (returnTo) {
      if (action === 'notify') {
        // Handle notification subscription after login
        fetch('/api/notify-me', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ itemId }),
        }).then(() => {
          alert('You will be notified when this item is back in stock!');
          navigate(returnTo);
        });
      } else {
        navigate(returnTo);
      }
    } else {
      navigate('/');
    }
  };

  return (
    <div className='auth-page'>
      <div className='auth-modal'>
        {mode === 'signup' && (
          <>
            <h2>Sign Up</h2>
            <form onSubmit={handleSubmit}>
              <input type='text' placeholder='Full Name' required />
              <input type='email' placeholder='Email' required />
              <div className='password-input'>
                <input type={showPassword ? 'text' : 'password'} placeholder='Password' required />
                <button
                  type='button'
                  className='toggle-password'
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
              <button type='submit' className='auth-btn' disabled={isLoading}>
                {isLoading ? 'Creating Account...' : 'Sign Up'}
              </button>
            </form>
            <p className='auth-switch'>
              Already have an account? <Link to='?mode=login'>Log In</Link>
            </p>
          </>
        )}
        {mode === 'login' && (
          <>
            <h2>Log In</h2>
            <form onSubmit={handleSubmit}>
              <input type='email' placeholder='Email' required />
              <div className='password-input'>
                <input type={showPassword ? 'text' : 'password'} placeholder='Password' required />
                <button
                  type='button'
                  className='toggle-password'
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
              <button type='submit' className='auth-btn' disabled={isLoading}>
                {isLoading ? 'Logging in...' : 'Log In'}
              </button>
            </form>
            <p className='auth-switch'>
              Need an account? <Link to='?mode=signup'>Sign Up</Link>
            </p>
            <Link to='/forgot-password' className='forgot-password'>
              Forgot Password?
            </Link>
          </>
        )}
        {(!mode || (mode !== 'signup' && mode !== 'login')) && (
          <p className='auth-error'>
            Invalid mode specified. Please use the Sign Up or Log In buttons.
          </p>
        )}
      </div>
    </div>
  );
};

export default AuthPage;
